import { mainRequests } from './custom'
import axios from 'axios'
import { getToken } from '../utils/auth'
export default {
  async getCampaigns (searchText) {
    try {
      const token = await getToken()
      const res = await axios.get(
        'https://rest.toktok.mn/crm/campaign/?status=active&search_text=' + searchText + '&size=1000&from=0',
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      if (res?.status === 200 && res?.data) {
        return res.data
      }
    } catch (err) {
      throw new Error(err)
    }
  },
  getDiscounts (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getDiscount('/discount' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getBrands (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllMall('/getBrands?' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getSuppliers (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllMall('/getSuppliers' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getProducts (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllMall('/getProducts' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getCategories () {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllMall('/getCategories')
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getServices () {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getServices('/getServices')
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  deleteDiscount (id) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .delDiscount('/discount' + '/' + id)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  addDiscount (body) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .postDiscount('/discount', body)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getOneDiscount (id) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getDiscount('/discount' + '/' + id)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getSuppliersApp (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllApp('/toktok/getPartners?search_text=' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getProductsApp (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllApp('/toktok/getProducts?search_text=' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getServicesApp (query) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .getAllApp('/toktok/getServices?search_text=' + query)
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
